import React, { memo, useCallback, useEffect, useMemo, useState, useContext } from 'react';
// import { H3 } from 'tea-component';
import { SortBy } from 'tea-component/lib/table/addons';
import { context as Context } from '@gp/components/Context';
// import TriggerViewCard from '@gp/components/TriggerViewCard';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import GeneralDownloadBtn from '@gp/components/GeneralDownloadBtn';
import { FILE_TYPES2, FILE_TYPES_MAP, SELECT_PANEL_HEIGHT, CONSTANT_TEXTS } from '@gp/constants/const';
import Table from './components/Table';
import { getProjectList } from '@gp/services/project';
import { queryOverviewDownLoad } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import { getDownLoadCSVResponseHeaderFileName, downloadFileByBlob, stream2Object } from '@gp/utils/common';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import { useRequest } from 'ahooks';
import classNames from 'classnames';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';

interface OverviewPropsType {
  className?: string;
  style?: React.CSSProperties;
  filterLoading: boolean;
  filterList: { id: string; name: string }[];
}

const DEFAULT_PROPS: OverviewPropsType = {
  className: '',
  style: {},
  filterLoading: true,
  filterList: [],
};

const DEFAULT_STAGES = ['development', 'pre-planned', 'planned'];

const formatParams = (params: any): any => {
  const { studio_id: studioId } = params || {};
  return {
    ...params,
    studio: studioId ? [studioId] : [],
  };
};

function Overview(props: OverviewPropsType) {
  const { className, style, filterLoading, filterList } = props;

  const [filterV, setFilterV] = useState<string[]>([]);
  // 控制是否请求接口，防止首次打开和关闭筛选器无操作，多余请求接口
  const [reqSwitch, setReqSwitch] = useState<boolean>(true);
  const [sortsParams, setSortsParams] = useState<SortBy<any>>({
    by: 'priority',
    order: 'desc' as any,
  });
  const [downloadFileType, setDownloadFileType] = useState<number>(2);

  const { studioName, studioId } = useContext<IStudioOverallProjectsDetailsContext>(Context) || {};

  const {
    loading: projectListLoading,
    data: projectList,
    run: projectListRun,
  } = useRequest(getProjectList, { manual: true });
  const {
    loading: downloadLoading,
    data: downloadData,
    run: runDownload,
  } = useRequest(queryOverviewDownLoad, { manual: true });

  // 接口参数，当前顶部筛选器选择项
  const searchV = useMemo(() => {
    return filterList?.length === filterV?.length
      ? []
      : filterList?.reduce((o: string[], t: { id: string; name: string }) => {
          o = filterV?.includes(t?.id) ? [...o, t?.name] : o;
          return o;
        }, []) || [];
  }, [filterList, filterV]);

  const handleDownload = (payload: any) => {
    runDownload({
      // @ts-ignore
      project_list_req: {
        studio: [studioId || ''],
        search: searchV,
        sort: sortsParams?.by,
        sort_type: sortsParams?.order as 'asc' | 'desc' | '',
      },
      file_type: payload?.fileType === FILE_TYPES_MAP.CSV ? 1 : 2,
      stage: 'development',
      no_pps: true,
    });
    setDownloadFileType(payload?.fileType || 2);
  };

  // 抛出下载后的文件
  const throwDownLoadResult = async () => {
    try {
      // 拿到响应头中的文件名称
      const fileName = getDownLoadCSVResponseHeaderFileName(downloadData?.headers);
      downloadFileByBlob(downloadData?.data, fileName);
      reportOperationLog(
        ALL_REPORT_OPERATION_LOG[
          downloadFileType == FILE_TYPES_MAP.CSV
            ? 'STUDIO_OVERALL_DETAIL_PROJECTS_OVERVIEW_CSV_SUBMIT'
            : 'STUDIO_OVERALL_DETAIL_PROJECTS_OVERVIEW_EXCEL_SUBMIT'
        ],
        'button',
      );
    } catch (err: any) {
      const resData = await stream2Object(err?.data);
      throw new Error(resData?.msg || '');
    }
  };
  // 下载结果
  useEffect(() => {
    if (downloadLoading || !downloadData) return;
    throwDownLoadResult();
  }, [downloadLoading]);

  const options = useMemo(() => {
    if (!Array.isArray(filterList) || !filterList?.length) {
      return [];
    }
    const _options = filterList?.map((t: { id: string; name: string }) => {
      return {
        value: t?.id || '',
        label: t?.name || '-',
        text: t?.name || '-',
        groupKey: 'separated',
      };
    });

    return _options;
  }, [filterList]);

  const handleChange = useCallback(
    (v: string[]) => {
      // 首次打开筛选器且全选关闭筛选器时
      const flag = !filterV?.length && v?.length === options?.length;
      setReqSwitch(!flag);
      setFilterV(v ? [...v] : []);
    },
    [filterV, options],
  );

  // 排序
  useEffect(() => {
    projectListRun(formatParams({
      // @ts-ignore
      sort: sortsParams?.by || '',
      sort_type: sortsParams?.order || '',
      search: searchV,
      studio: [studioName || ''],
      studio_id: studioId || '',
      stage: DEFAULT_STAGES,
    }));
  }, [sortsParams?.by, sortsParams?.order]);

  // 筛选器变化
  useEffect(() => {
    if (!Array.isArray(filterV) || !filterV?.length) return;
    if (!reqSwitch) {
      setReqSwitch(true);
      return;
    }
    projectListRun(formatParams({
      // @ts-ignore
      sort: sortsParams?.by || '',
      sort_type: sortsParams?.order || '',
      search: searchV,
      studio: [studioName || ''],
      studio_id: studioId || '',
      stage: DEFAULT_STAGES,
    }));
  }, [filterV]);

  // const tabs = useMemo(() => {
  //   return [
  //     {
  //       id: 'download',
  //       label: (
  //         <GeneralDownloadBtn
  //           uiType="2"
  //           fileTypes={FILE_TYPES2}
  //           isLoading={downloadLoading}
  //           onConfirm={handleDownload}
  //         />
  //       ),
  //       component: (
  //         <>
  //           <GPSelectMultiple
  //             className="dbg-studio-overall-details-projects-dev-overview-project-selector"
  //             label="Project"
  //             listHeight={SELECT_PANEL_HEIGHT}
  //             staging={false}
  //             searchable
  //             clearable
  //             allOption={{
  //               text: 'All',
  //               value: 'all',
  //             }}
  //             groups={{ separated: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME }}
  //             options={options}
  //             value={filterV}
  //             onChange={handleChange}
  //           />
  //           <Table
  //             data={projectList}
  //             loading={projectListLoading}
  //             setSortsParams={setSortsParams}
  //           />
  //         </>
  //       ),
  //     },
  //   ];
  // }, [
  //   downloadLoading,
  //   options,
  //   filterV,
  //   projectList,
  //   projectListLoading,
  //   sortsParams,
  // ]);

  return (
    <CardSlot
      className={classNames({
        'dbg-studio-overall-details-projects-dev-overview': true,
        [className as string]: !!className,
      })}
      style={style}
      title={'Overview'}
      loading={false}
      isNoData={false}
      rightDom={
        <GeneralDownloadBtn uiType="2" fileTypes={FILE_TYPES2} isLoading={downloadLoading} onConfirm={handleDownload} />
      }
    >
      <GPSelectMultiple
        className="dbg-studio-overall-details-projects-dev-overview-project-selector"
        label="Project"
        listHeight={SELECT_PANEL_HEIGHT}
        staging={false}
        searchable
        clearable
        disabled={filterLoading}
        allOption={{
          text: 'All',
          value: 'all',
        }}
        groups={{ separated: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME }}
        options={options}
        value={filterV}
        onChange={handleChange}
      />
      <Table data={projectList} loading={projectListLoading} setSortsParams={setSortsParams} />
    </CardSlot>
  );
}

Overview.defaultProps = DEFAULT_PROPS;

export default memo(Overview);
